import {useEffect} from 'react';
import {RootState, dispatch} from '@store';
import {
  loginActions,
  loginReducerLogout,
} from '@pages/Login/auth/store/loginReducer';
import {useSelector} from 'react-redux';
import {postIndriveMessage} from '@shared/utils/indriveMessages';

function IdleDetector() {
  const {idleTime, countryCode, theme} = useSelector(
    (state: RootState) => state.login
  );
  const isIndrive = useSelector(
    (state: RootState) => state.dashboard.isIndrive
  );
  const timeout =
    countryCode === 'ID' && (theme === 'indrive' || isIndrive)
      ? 15 * 60 * 1000
      : idleTime;

  useEffect(() => {
    let idleTimer: ReturnType<typeof setTimeout>;
    const handleTimeout = () => {
      postIndriveMessage({type: 'TIMEOUT', payload: {}}, '*');
      dispatch(loginReducerLogout());
      dispatch(loginActions.setIsShowOtp(false));
      dispatch(loginActions.setIsSelectBRN(false));
      dispatch(loginActions.setIsLogout(true));
      dispatch(loginActions.setIdleTimeout(true));
    };
    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(handleTimeout, timeout);
    };
    const events = [
      'mousemove',
      'keydown',
      'pointerdown',
      'touchstart',
      'scroll',
    ];
    resetIdleTimer();
    events.forEach((event) =>
      window.addEventListener(event, resetIdleTimer, {passive: true})
    );
    return () => {
      clearTimeout(idleTimer);
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
    };
  }, [timeout]);
  return null;
}

export default IdleDetector;
